const BATCH_UPLOAD_TEMPLATE =
  'https://storage.googleapis.com/immersive-quest/files/Batch_Upload_Template_2.xlsx'

export { BATCH_UPLOAD_TEMPLATE }
